// <s-header-pincode> powers the header "Deliver to" picker. It shares the saved pincode with
// <s-delivery-check> on product pages (same storage key + `tassya:pincode` event), so a code
// entered in either place shows in both.
const STORAGE_KEY = 'tassya:delivery-pincode';
const PIN_PATTERN = /^[1-9]\d{5}$/;

class SHeaderPincode extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const input = this.querySelector('[data-pincode-input]');

    this.addEventListener('command', (event) => {
      if (event.command === '--save') this.#save();
    }, opts);

    input?.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      input.removeAttribute('aria-invalid');
      this.#showError(false);
    }, opts);

    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.#save();
      }
    }, opts);

    document.addEventListener('tassya:pincode', (event) => {
      if (event.detail?.pin) this.#render(event.detail.pin);
    }, opts);

    let saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch {}
    this.#render(saved);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #save() {
    const input = this.querySelector('[data-pincode-input]');
    const pin = String(input?.value || '').trim();
    if (!PIN_PATTERN.test(pin)) {
      input?.setAttribute('aria-invalid', 'true');
      this.#showError(true);
      input?.focus();
      return;
    }
    try { localStorage.setItem(STORAGE_KEY, pin); } catch {}
    this.#render(pin);
    document.dispatchEvent(new CustomEvent('tassya:pincode', { detail: { pin, source: this } }));
    this.querySelector('[popover]')?.hidePopover?.();
  }

  #render(pin) {
    const value = this.querySelector('[data-pincode-value]');
    const input = this.querySelector('[data-pincode-input]');
    if (!value) return;
    if (pin && PIN_PATTERN.test(pin)) {
      value.textContent = (this.dataset.labelTemplate || '__CODE__').replace('__CODE__', pin);
      if (input) input.value = pin;
    } else {
      value.textContent = this.dataset.emptyLabel || '';
    }
  }

  #showError(show) {
    const error = this.querySelector('[data-pincode-error]');
    if (error) error.hidden = !show;
  }
}

if (!customElements.get('s-header-pincode')) customElements.define('s-header-pincode', SHeaderPincode);
